import {
  faBuilding,
  faCog,
  faSignOutAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import userAvatar from 'assets/img/user-avatar.png';
import Avatar from 'components/common/Avatar';
import useApi from 'helpers/api';
import { useAuthenticatedUser } from 'hooks/useAuthenticatedUser';
import { useOAuth2 } from 'hooks/useOAuth2';
import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AgentPhotoService from 'services/AgentPhoto.service';

const ProfileDropdown = () => {
  const api = useApi();
  const { authenticatedUser } = useAuthenticatedUser();
  const { resetOAuthState } = useOAuth2();

  const [userPhoto, setUserPhoto] = useState({ url: '' });

  useEffect(() => {
    if (authenticatedUser?.id) getUserPhoto();
  }, [authenticatedUser]);

  const getUserPhoto = async () => {
    if (!authenticatedUser?.id) return;
    /* let request = await api.agentPhoto.find(authenticatedUser.id); */
    let request = await AgentPhotoService.find(authenticatedUser.id);
    if (request.ok) {
      const response = await request.json();
      setUserPhoto(response);
    }
  };

  /**
   * Realiza logout limpando o estado OAuth2 local antes de redirecionar
   * para o servidor. Isso previne erros invalid_grant no próximo login.
   */
  const handleLogout = e => {
    e.preventDefault();

    // Limpar todos os cookies de autenticação (token, SESSION, oauth2_*)
    resetOAuthState();

    // Redirecionar para o servidor OAuth2 para logout
    window.location.href = `${process.env.REACT_APP_BASE_URL}/logout`;
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={userPhoto.url || userAvatar} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 dark__bg-1000">
          <div className="px-3">
            <strong className="text-body-emphasis fs-9">
              {authenticatedUser?.firstName} {authenticatedUser?.lastName}
            </strong>
            <p className="text-secondary fs-11 m-0">
              {authenticatedUser?.email}
            </p>
          </div>

          <Dropdown.Divider />

          <Dropdown.Item as={Link} to="/user/profile">
            <FontAwesomeIcon icon={faUser} className="me-2" />
            Meu Perfil
          </Dropdown.Item>

          <Dropdown.Item as={Link} to="/company/my-company">
            <FontAwesomeIcon icon={faBuilding} className="me-2" />
            Dados da minha empresa
          </Dropdown.Item>

          <Dropdown.Item as={Link} to="/settings">
            <FontAwesomeIcon icon={faCog} className="me-2" />
            Configurações
          </Dropdown.Item>

          <Dropdown.Divider />

          <Dropdown.Item
            href="#"
            onClick={handleLogout}
            className="text-danger"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
            Sair
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
